<template>
  <div class="saleReport">
    <div class="title">
      <i class="el-icon-s-comment" style="color: #006eff"></i>
      销售简报
    </div>
    <ul>
      <li v-for="(item,index) in 6" :key="index">
        <div class="itemName">{{ datas[index].name }}</div>
        <div class="num">
          <b>{{ datas[index].num }}</b>
          <span>{{ datas[index].unit }}</span>
        </div>
        <div class="compare" v-if="index!==5">
          <div class="desc">较上月</div>
          <div v-if="datas[index].percent>=0" class="differ el-icon-top-right">{{ datas[index].percent }}%</div>
          <div v-if="datas[index].percent<0" class="differ el-icon-bottom-right">{{ Math.abs(datas[index].percent) }}%</div>
        </div>
      </li>
    </ul>
  </div>
</template>

<script>
export default {
  data() {
    return {
      titleList: ['新增客户', '新增联系人', '新增项目', '合同金额', '回款金额', '公海资源'],
      datas: [
        {
          name: "新增客户",
          num: 0,
          percent: 0,
          unit: "位",
        },
        {
          name: "新增联系人",
          num: 0,
          percent: 0,
          unit: "位",
        },
        {
          name: "新增项目",
          num: 0,
          percent: 0,
          unit: "个",
        },
        {
          name: "合同金额",
          num: 0,
          percent: 0,
          unit: "元",
        },
        {
          name: "回款金额",
          num: 0,
          percent: 0,
          unit: "元",
        },
        {
          name: "公海资源",
          num: 0,
          unit: "个",
        },
      ],
    }
  },
  created() {
    this.getData();
  },
  methods: {
    getData() {
      this.$axios.get(`/Crm/Static/SalesKit`).then(res => {
        this.datas = [
          {
            name: "新增客户",
            num: res.customer.count,
            percent: res.customer.percent,
            unit: "位",
          },
          {
            name: "新增联系人",
            num: res.linker.count,
            percent: res.linker.percent,
            unit: "位",
          },
          {
            name: "新增项目",
            num: res.contract.count,
            percent: res.contract.percent,
            unit: "个",
          },
          {
            name: "合同金额",
            num: res.contractAmount.amount,
            percent: res.contractAmount.percent,
            unit: "元",
          },
          {
            name: "回款金额",
            num: res.collectionAmount.amount,
            percent: res.collectionAmount.percent,
            unit: "元",
          },
          {
            name: "公海资源",
            num: res.shareCustCount,
            unit: "个",
          },
        ]
      })
    },
  }
}
</script>

<style scoped lang="scss">
.saleReport {
  box-sizing: border-box;
  border: 1px solid #dfe0eb;
  border-radius: 12px;
  border-top: 3px solid #006eff;
  padding: 5px 0 5px 15px;
  margin-bottom: 20px;
  background: white;
  box-shadow: 0 2px 6px 0 rgba(218, 218, 253, 65%), 0 2px 6px 0 rgba(206, 206, 238, 54%);

  .title {
    font-weight: bold;
    font-size: 18px;
    margin-bottom: 10px;
    margin-top: 10px;
  }

  ul {
    display: flex;
    justify-content: space-between;
    flex-wrap: wrap;

    li {
      flex: 1;
      border: 1px solid #dfe0eb;
      border-radius: 5px;
      min-width: 180px;
      padding: 5px 15px;
      margin-right: 25px;
      margin-bottom: 15px;
      transition: all .2s;
      background: #F4F5F7;
      box-shadow: 5px 5px 0 rgb(200, 200, 200);

      .itemName {
        font-weight: bold;
        font-size: 16px;
      }

      .num {
        b {
          font-size: 22px;
        }
      }

      .compare {
        display: flex;
        align-items: center;

        .el-icon-top-right {
          font-weight: bold;
          color: #17a00e;
        }

        .el-icon-bottom-right {
          font-weight: bold;
          color: #f41127;
        }
      }
    }
  }
}
</style>
